var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17.594,
    viewBox: "0 0 24 17.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(18518.148 23366.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M24,1H0V-1H24Z",
    transform: "translate(-18518.148 -23365.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M24,1H0V-1H24Z",
    transform: "translate(-18518.148 -23357.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_11",
    "data-name": "Line 11",
    d: "M24,1H0V-1H24Z",
    transform: "translate(-18518.148 -23349.906)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerWhite);
export default __webpack_public_path__ + "static/media/burger-white.5e8d5a6bbbbae6d615560faf15ed444c.svg";
export { ForwardRef as ReactComponent };